<template>
    <div>
      <vs-progress :percent="passwordStrength" :color="passwordColor" :rounded="true"></vs-progress>
      <p class="text-danger" v-if="passwordLevel === 'weak'">Senha Fraca</p>
      <p class="text-warning" v-else-if="passwordLevel === 'average'">Senha Média</p>
      <p class="text-success" v-else-if="passwordLevel === 'strong'">Senha Forte</p>
      <div>
        <span class="font-bold">Veja os requisitos mínimos para cadastrar uma senha forte:</span><br>
        <ul class="bullet-list ml-8">
          <li><span :class="hasUppercase ? 'green' : 'red'">1 letra maiúscula</span></li>
          <li><span :class="hasLowercase ? 'green' : 'red'">1 letra minúscula</span></li>
          <li><span :class="hasNumber ? 'green' : 'red'">1 caracter numérico</span></li>
          <li><span :class="hasSpecialChar ? 'green' : 'red'">2 caracteres especiais</span></li>
          <li><span :class="isLongEnough ? 'green' : 'red'">8 caracteres em toda senha</span></li>
          <li><span :class="isNotSequencial ? 'green' : 'red'">Não deve conter números e letras repetidas ou sequenciais</span></li>
        </ul>
      </div>
      <div class="warning">
        <div class="icon">
          <i class="fas fa-exclamation-circle"></i>
        </div>
        <div class="content">
          <p class="font-bold">Segue um exemplo de senha forte:</p>
          <p>Ped496#*</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { filterPassword } from '@/utils'
  
  export default {
    name: 'PasswordStrong',
    props: {
      password: {
        type: String,
        required: true,
        default: '',
      },
    },
    data() {
      return {
        passwordStrength: 0,
        passwordColor: '',
        hasUppercase: false,
        hasLowercase: false,
        hasNumber: false,
        hasSpecialChar: false,
        isLongEnough: false,
        isNotSequencial: false
      }
    },
    computed: {
      passwordLevel() {
        if (!this.password) {
          return '';
        } else {
          const passwordStrength = filterPassword(this.password);
          if (passwordStrength <= 50) {
            return 'weak';
          } else if (passwordStrength > 50 && passwordStrength <= 75) {
            return 'average';
          } else {
            return 'strong';
          }
        }
      }
    },
    watch: {
      password() {
        this.updatePasswordStrength();
      }
    },
    methods: {
      updatePasswordStrength() {
        setTimeout(() => {
          if (this.password.length < 1) {
            this.passwordStrength = 0;
            this.hasUppercase = false;
            this.hasLowercase = false;
            this.hasNumber = false;
            this.hasSpecialChar = false;
            this.isLongEnough = false;
            this.isNotSequencial = false;
            this.updatePasswordColor();
          } else {
            this.passwordStrength = filterPassword(this.password);
          const password = this.password;
          if (password.length <= 0) {
            this.hasUppercase = false;
            this.hasLowercase = false;
            this.hasNumber = false;
            this.hasSpecialChar = false;
            this.isLongEnough = false;
            return;
          }
          this.hasUppercase = /[A-Z]/.test(password);
          this.hasLowercase = /[a-z]/.test(password);
          this.hasNumber = /[0-9]/.test(password);
          this.hasSpecialChar = /[^A-Za-z0-9]/g.test(password) && (password.match(/[^A-Za-z0-9]/g) || []).length >= 2;
          this.isLongEnough = password.length >= 8;
          this.isNotSequencial = !(/(\w)\1{2}/.test(password) || /(?:012|123|234|345|456|567|678|789|890|abc|bcd|cde|def|efg|fgh|ghi|hij|ijk|jkl|klm|lmn|mno|nop|opq|pqr|qrs|rst|stu|tuv|uvw|vwx|wxy|xyz)/i.test(password));
        }
        this.updatePasswordColor();
      }, 0);
    },
    updatePasswordColor() {
      if (this.passwordStrength <= 1) {
        this.passwordColor = '';
      } else if (this.passwordStrength <= 50) {
        this.passwordColor = 'danger';
      } else if (this.passwordStrength <= 75) {
        this.passwordColor = 'warning';
      } else {
        this.passwordColor = 'success';
      }
    },
  },
  created() {
    this.updatePasswordStrength();
  },
  mounted() {
    this.passwordStrength = 0;
  },
};
</script>
<style>
.green {
  color:  #46c93a;
}

.red {
  color: #ff4757;
}
.warning {
  display: flex;
  align-items: center;
  background-color: #fff7d0;
  color: #b29400;
  padding: 15px;
  border-radius: 6px;
  border: 2px solid #b29400;
  margin-top: 10px;
}

.warning .icon {
  margin-right: 20px;
  font-size: 24px;
}

.warning h4 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  color: #b29400;
}

.warning p {
  font-size: 14px;
  line-height: 1.4;
}
.font-bold{
  font-weight: bold;
}
</style>
  